document.addEventListener('DOMContentLoaded', function() {
  const popupButtons = document.querySelectorAll('.google_popup_open');
  const googleShoppingPopup = document.querySelector('.google_shopping_popup');

  // Check if both elements exist
  if (popupButtons.length > 0 && googleShoppingPopup) {
    popupButtons.forEach(button => {
      button.addEventListener('click', function() {
        googleShoppingPopup.classList.add('active');
      });
    });

    const closePopupButton = document.querySelector('.google_shopping_popup_close');
    if (closePopupButton) {
      closePopupButton.addEventListener('click', function() {
        googleShoppingPopup.classList.remove('active');
      });
    }
  }
});
